<template>
  <div class="sync">
    <el-dialog
      :close-on-click-modal="false"
      title="整店搬家"
      width="900px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <el-row style="font-size:14px;" :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div style="margin: 20px 0 20px 0;">源店铺</div>
            <div class="shop-area">
              <div>
                <span style="margin: 0 50px 0 0;">店铺</span>
                <el-select
                  style="width:200px"
                  placeholder="请选择源店铺"
                  clearable
                  filterable
                  size="small"
                  v-model="form.fromShopId"
                  @change="handleChangeShop"
                >
                  <el-option
                    v-for="value in shopList"
                    :key="value.shopId"
                    :label="value.shopName"
                    :value="value.shopId"
                  >
                  </el-option>
                </el-select>
              </div>
              <div v-if="false">
                <span style="margin: 0 50px 0 0;">产品</span>
                <el-select
                  style="width:200px"
                  placeholder="请选择产品"
                  clearable
                  multiple
                  filterable
                  size="small"
                  v-model="form.pIds"
                >
                  <el-option
                    v-for="value in productList"
                    :key="value.shopId"
                    :label="value.shopName"
                    :value="value.shopId"
                  >
                  </el-option>
                </el-select>
              </div>

              <div>
                <span style="margin: 0 20px 0 0;">产品状态</span>
                <el-radio v-model="form.productStatus" label="normal"
                  >在售</el-radio
                >
                <el-radio v-model="form.productStatus" label="all"
                  >全部</el-radio
                >
              </div>
              <div>已选择 {{ total }} 个产品</div>
            </div>
          </div></el-col
        >
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <div style="margin: 20px 0 20px 0;">搬家至</div>
            <div style="height:150px" class="shop-area">
              <div v-if="false">
                <span style="margin: 0 50px 0 0;">平台</span>
                <el-select
                  style="width:200px"
                  placeholder="请选择平台"
                  clearable
                  filterable
                  size="small"
                  v-model="toPlatNo"
                  @change="handleChangePlatNo"
                >
                  <el-option
                    v-if="value.value != platNo"
                    v-for="value in platFormList"
                    :key="value.value"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <span style="margin: 0 50px 0 0;">店铺</span>
                <el-select
                  style="width:200px"
                  placeholder="请选择目的店铺"
                  clearable
                  filterable
                  size="small"
                  v-model="form.toShopId"
                >
                  <el-option
                    v-if="form.fromShopId && value.shopId != form.fromShopId"
                    v-for="value in shopList"
                    :key="value.shopId"
                    :label="value.shopName"
                    :value="value.shopId"
                  >
                  </el-option>
                </el-select>
              </div>
            </div></div
        ></el-col>
      </el-row>

      <el-row style="margin: 30px 0 20px 0;" :gutter="20">
        <el-col :span="24"
          ><div class="grid-content bg-purple">
            <span style="margin: 0 20px 0 0;">重复产品</span>
            <el-radio v-model="form.isRepeat" label="01">复制</el-radio>
            <el-radio v-model="form.isRepeat" label="02">跳过</el-radio>
          </div></el-col
        >
      </el-row>
      <el-row style="margin: 25px 0 20px 0;" :gutter="20">
        <el-col :span="24"
          ><div class="grid-content bg-purple">
            <span style="margin: 0 20px 0 0;">复制方式</span>
            <el-radio v-model="form.copyType" label="online">上线</el-radio>
            <el-radio v-model="form.copyType" label="draff">草稿</el-radio>
          </div></el-col
        >
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sureImport" size="small">
          确定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="同步产品"
      width="40%"
      class="sync-order"
      :visible.sync="loadingVisible"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        :percentage="percent"
        status="success"
      ></el-progress>
      <div class="status">
        状态：
        <span class="red">
          {{
            percent >= 100
              ? successFlag
                ? "已完成!" + (this.showMessage ? "(" + this.message + ")" : "")
                : "同步失败"
              : "进行中..."
          }}
        </span>
      </div>
      <div class="detail" v-if="resultList.length > 0">
        详情：
        <div class="detail-wrap">
          <div class="list" v-for="(item, index) in resultList" :key="index">
            {{ item.name }}，
            {{ item.status === "success" ? "同步成功！" : "同步失败！" }}
            <span :class="item.status === 'success' ? '' : 'red'">
              {{
                item.status === "success"
                  ? `共成功同步${item.count}条数据！`
                  : `失败原因：${item.reason}`
              }}
            </span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose" size="small">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getShopList } from "@/api/system/shopManage"
import { moveProduct } from "@/api/order/all"
import { mapGetters } from "vuex"
import { getProductList as getProductListLazada } from "@/api/order/lazada"
import { getProductList as getProductListShopee } from "@/api/order/shopee"
import { getProductList as getProductListTiktok } from "@/api/order/tiktok"
import { getUserProfile } from "@/api/system/user"
import { syncByShopShopee } from "@/api/order/shopee"
import { syncByShopTiktok } from "@/api/order/tiktok"

export default {
  name: "CopyProduct",
  data() {
    return {
      shopList: [],
      multipleSelection: [],
      percent: 0,
      loadingVisible: false,
      resultList: [],
      timer: null,
      successFlag: false,
      message: "数据可能延迟，请稍后刷新",
      showMessage: false,
      toPlatNo: "",
      form: {
        fromShopId: "",
        productStatus: "normal",
        pIds: "",
        isRepeat: "01",
        toShopId: "",
        copyType: "online",
      },
      toShopList: [],
      productList: [],
      platFormList: [
        {
          value: "03",
          label: "Lazada",
        },
        {
          value: "05",
          label: "Shopee",
        },
        {
          value: "10",
          label: "Tiktok",
        },
      ],
      total: 0,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    platNo: {
      type: String,
      default() {
        return "04"
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          fromShopId: "",
          productStatus: "normal",
          pIds: "",
          isRepeat: "01",
          toShopId: "",
          copyType: "online",
        }
        this.shopList = []
        this.toShopList = []
        this.total = 0
        this.toPlatNo = ""
        this.getData()
      }
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  mounted() {},
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    async getProductList() {
      let result = ""
      if (this.platNo == "03") {
        result = await getProductListLazada({
          pageNum: 1,
          pageSize: 1,
          shopId: this.form.fromShopId,
          status: "active",
        })
      }
      if (this.platNo == "05") {
        result = await getProductListShopee({
          pageNum: 1,
          pageSize: 1,
          shopId: this.form.fromShopId,
          status: "active",
        })
      }
      if (this.platNo == "10") {
        result = await getProductListTiktok({
          pageNum: 1,
          pageSize: 1,
          shopId: this.form.fromShopId,
          status: "active",
        })
      }
      this.total = result.total
    },
    checkSelectable(row) {
      return row.authStatus == "02" && !row.isExpire
    },
    handleChangePlatNo() {
      getShopList({ platNo: this.toPlatNo, authStatus: "02" }).then((res) => {
        this.toShopList = res.rows
      })
    },
    getData() {
      getShopList({ platNo: this.platNo, authStatus: "02" }).then((res) => {
        this.shopList = res.rows
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.$emit("onClose")
      this.$emit("update")
      this.loadingVisible = false
    },
    completeDate(value) {
      return value < 10 ? "0" + value : value
    },
    handleChangeShop() {
      this.form.toShopId = ""
      this.getProductList()
    },
    async sureImport() {
      let form = this._.clone(this.form)
      if (form.fromShopId == "") {
        this.msgError("请选择源店铺")
        return
      }
      if (form.toShopId == "") {
        this.msgError("请选择目的店铺")
        return
      }
      let result = await getUserProfile()
      if (Number(result.user.vipType) < 2) {
        this.msgError("会员等级VIP2及以上可以使用")
        return
      }
      this.events.$emit("showSyncHint", true)
      moveProduct(form)
        .then((res) => {
          this.msgSuccess("店铺搬家处理成功")
          this.events.$emit("showSyncHint", false)
        })
        .catch((error) => {
          this.events.$emit("showSyncHint", false)
        })
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}
.sync-table {
  overflow-y: auto;
  max-height: 260px;
}
.status {
  margin: 10px 0;
}
.red {
  color: red;
}
.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}
.detail .list {
  padding: 5px 20px;
  box-sizing: border-box;
  width: 100%;
}

.shop-area {
  line-height: 50px;
  border: 1px solid #dddddd;
  padding: 20px;
}
</style>
